
/**
 * Returns true if given directory item is favorite
 * @param {object} directoryItem Directory item (or echibitor) object
 * @returns boolean
 */
export function isDirectoryItemFavorite(directoryItem) {
    return directoryItem.is_favorite;
}
